/**
 * "Learn this" targets: where a link from the app or from a help topic opens the
 * training. The platform places the links; this file only says where they lead and what
 * they say.
 */

import type { HelpTopicId } from "@/features/help";
import type { LinkSpot, TrainingTarget } from "@/features/training/types";

export const TRAINING_LINKS: Record<LinkSpot, TrainingTarget> = {
  queue: { module: "queue", slide: "q2", text: "Learn this: find your whole backlog" },
  "queue-closed": {
    module: "status",
    slide: "s2",
    text: "Learn this: Closed is not a reply",
  },
  "back-for-you": {
    module: "status",
    slide: "s3",
    text: "Learn this: reopen a case that came back",
  },
  case: { module: "customer", slide: "c1", text: "Learn this: the three steps of a case" },
  customer: { module: "customer", slide: "c2", text: "Learn this: confirm only with evidence" },
  lines: { module: "lines", slide: "l2", text: "Learn this: find a wrong row" },
  reply: { module: "reply", slide: "r3", text: "Learn this: correct the reply and copy it" },
  // Mounted in the checks section of the Details sheet (the rules panel).
  "price-approval": {
    module: "prices",
    slide: "p2",
    text: "Learn this: who approves a price",
  },
};

export const HELP_TOPIC_TRAINING: Partial<Record<HelpTopicId, TrainingTarget>> = {
  "what-it-is": { module: "welcome", slide: "w1", text: "Practise this in the training" },
  queue: { module: "queue", slide: "q1", text: "Practise this in the training" },
  customer: { module: "customer", slide: "c2", text: "Practise this in the training" },
  "case-page": { module: "lines", slide: "l1", text: "Practise this in the training" },
  "prepared-replies": { module: "reply", slide: "r3", text: "Practise this in the training" },
  statuses: { module: "status", slide: "s2", text: "Practise this in the training" },
  "back-for-you": { module: "status", slide: "s3", text: "Practise this in the training" },
  feedback: { module: "extras", slide: "x1", text: "Practise this in the training" },
  "rules-and-countries": {
    module: "extras",
    slide: "x2",
    text: "Practise this in the training",
  },
  translation: { module: "extras", slide: "x3", text: "Practise this in the training" },
  "work-faster": { module: "extras", slide: "x4", text: "Practise this in the training" },
};
